module.exports = __webpack_public_path__ + "img/26.44a9eef7.png";